export { default as landingData } from './landingData';
export { default as hpData } from './hpData';
export { default as styleData } from './styleData';
export { default as noData } from './noData';
